import React, { useEffect, useState } from "react";
import InputTextElementElement from "../UiComponents/InputTextElement";
import ButtonElement from "../UiComponents/ButtonElement";
import { forgetPassword } from "../../Services/passwordService";
import { Link } from "react-router-dom";
import { Message } from "primereact/message";
import Loader from "../UiComponents/Loader";
import useToggle from "../../Hooks/useToggle";

export const ForgetPassword = () => {
  const [data, setData] = useState({
    username: "",
    emailId: "",
  });
  const [loader, setLoader] = useToggle();
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleEvent = (e) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSubmit = async () => {
    setLoader();
    const response = await forgetPassword(data);
    if (response.data.userExist) {
      setErrorMessage("");
      setMessage(response.data.message);
    } else {
      setMessage("");
      setErrorMessage(response.data.message);
    }
    setLoader();
  };
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [data]);

  return (
    <>
<div className=''>
        <div className='row mt-0'>
          <div className='col-lg-7 col-md-7 d-none d-md-block gradient-bg' >
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <img src="./images/esg.svg" alt="testing error" className="mb-3 w-25" />
              <div className="d-flex flex-columnjustify-content-center align-items-center">
                <h3 className="text-left text-white">
                  ESG made Easy - to <br />operationalise ESG across your<br />Organisation
                </h3>
              </div>
            </div>
          </div>
          <div className='d-flex flex-column justify-content-center align-items-center col-lg-5 col-md-5 col-sm-12'>
            <div className='d-flex justify-content-center align-items-center w-75'>
              <img src="./images/myconsoleLogo.png" alt="" className="w-50 mt-5"/>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-5 w-100'>
              <div className="px-3">
                <h3 className='welcome-heading mb-2'>Forgotten Password !!</h3>
              <p className="fs-8 m-0 mb-4">Enter Details below to reset your password.</p>
                <div className='mt-4'>
                <InputTextElementElement
                className="mc-input w-100"
                type="text"
                placeholder="Enter Username"
                name="username"
                onChange={(e) => handleEvent(e)}
              />
                </div>
                <div className='mt-4'>
                <InputTextElementElement
                className="mc-input w-100"
                type="email"
                placeholder="Enter Email"
                name="emailId"
                onChange={(e) => handleEvent(e)}
              />
                </div>

                <div className='d-flex justify-content-end' >
                <p className="forget-text">
              An email will be sent to your inbox to advice you on how to reset
              your password
            </p>
                </div>
                {message && message ? (
              <Message severity="success" className="w-100" text={message} />
            ) : null}
            {errorMessage && errorMessage ? (
              <Message severity="error" className="w-100" text={errorMessage} />
            ) : null}
                <div className="d-flex mt-4 mb-5">
                <ButtonElement
              className="w-100 login-btn"
              label="Submit"
              onClick={handleSubmit}
            />
                  {loader && loader ? <Loader loading={loader} /> : ""}
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-3' >
              <div className='px-1'>
              <p>© myConsole Ltd</p>              </div>
              <div className='px-1'>
                <p>
                  <Link to={"/securityPolicies"}>Privacy Policy</Link>
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};
